var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6599 5.71622C15.6895 3.00296 12.9096 5.69876 12.8808 5.72696L10.7095 7.89556L11.1839 8.37038L13.3538 6.20313C13.4491 6.10977 15.7117 3.93312 18.2077 6.21186C18.9176 6.86062 19.2933 7.59535 19.3269 8.39522C19.3884 9.89629 18.2326 11.1798 18.1978 11.2184L18.197 11.2193L15.8183 13.5954L16.3574 14.0055L18.6787 11.6867C18.7358 11.6256 20.069 10.1776 19.9972 8.37306C19.9583 7.38514 19.5087 6.49057 18.6599 5.71622Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2416 15.7445L13.6458 15.2913C13.15 15.5126 12.5895 15.6404 12.0515 15.496C10.8565 15.1777 9.88554 14.1985 9.5004 13.762L10.374 12.8027L9.83781 12.3949L8.61806 13.7338L8.78715 13.9567C8.84016 14.0259 10.107 15.6727 11.879 16.1448C12.0951 16.2026 12.3105 16.2274 12.5238 16.2274C13.1426 16.2274 13.7384 16.0129 14.2416 15.7445Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7583 12.0286L14.4962 11.2475C14.1084 10.8096 13.1395 9.83513 11.9479 9.51747C11.4956 9.39606 11.0278 9.46657 10.596 9.62331L9.98192 9.15627C10.6157 8.85736 11.3684 8.66915 12.121 8.86803C13.893 9.34084 15.1598 10.9883 15.2129 11.0574L15.384 11.2844L14.2955 12.4372L13.7583 12.0286Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80327 10.8475L8.34244 11.2576L5.80304 13.7942C5.77119 13.8295 4.61146 15.1155 4.67311 16.6183C4.70599 17.4188 5.0824 18.1536 5.7923 18.8016C8.29572 21.0891 10.5502 18.9057 10.6455 18.8117L12.8154 16.6431L13.2898 17.1186L11.1192 19.2872C11.1004 19.306 9.86112 20.5068 8.15885 20.5068C7.30469 20.5068 6.33244 20.2046 5.34006 19.298C4.49127 18.5229 4.04172 17.6284 4.0028 16.6411C3.931 14.8365 5.26357 13.3886 5.3206 13.3274L7.80327 10.8475Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6599 5.71622C15.6895 3.00296 12.9096 5.69876 12.8808 5.72696L10.7095 7.89556L11.1839 8.37038L13.3538 6.20313C13.4491 6.10977 15.7117 3.93312 18.2077 6.21186C18.9176 6.86062 19.2933 7.59535 19.3269 8.39522C19.3884 9.89629 18.2326 11.1798 18.1978 11.2184L18.197 11.2193L15.8183 13.5954L16.3574 14.0055L18.6787 11.6867C18.7358 11.6256 20.069 10.1776 19.9972 8.37306C19.9583 7.38514 19.5087 6.49057 18.6599 5.71622Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2416 15.7445L13.6458 15.2913C13.15 15.5126 12.5895 15.6404 12.0515 15.496C10.8565 15.1777 9.88554 14.1985 9.5004 13.762L10.374 12.8027L9.83781 12.3949L8.61806 13.7338L8.78715 13.9567C8.84016 14.0259 10.107 15.6727 11.879 16.1448C12.0951 16.2026 12.3105 16.2274 12.5238 16.2274C13.1426 16.2274 13.7384 16.0129 14.2416 15.7445Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7583 12.0286L14.4962 11.2475C14.1084 10.8096 13.1395 9.83513 11.9479 9.51747C11.4956 9.39606 11.0278 9.46657 10.596 9.62331L9.98192 9.15627C10.6157 8.85736 11.3684 8.66915 12.121 8.86803C13.893 9.34084 15.1598 10.9883 15.2129 11.0574L15.384 11.2844L14.2955 12.4372L13.7583 12.0286Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80327 10.8475L8.34244 11.2576L5.80304 13.7942C5.77119 13.8295 4.61146 15.1155 4.67311 16.6183C4.70599 17.4188 5.0824 18.1536 5.7923 18.8016C8.29572 21.0891 10.5502 18.9057 10.6455 18.8117L12.8154 16.6431L13.2898 17.1186L11.1192 19.2872C11.1004 19.306 9.86112 20.5068 8.15885 20.5068C7.30469 20.5068 6.33244 20.2046 5.34006 19.298C4.49127 18.5229 4.04172 17.6284 4.0028 16.6411C3.931 14.8365 5.26357 13.3886 5.3206 13.3274L7.80327 10.8475Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74376 8.19839L7.37916 9.17246L7.20019 9.84039L3.5648 8.86633L3.74376 8.19839Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59052 5.30981L8.25183 7.97108L7.76288 8.46004L5.10156 5.79878L5.59052 5.30981Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.182 16.8153L16.5466 15.8412L16.7256 15.1733L20.361 16.1473L20.182 16.8153Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3353 19.7039L15.6739 17.0426L16.1629 16.5536L18.8242 19.2149L18.3353 19.7039Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLink);
export default __webpack_public_path__ + "static/media/UnLink.db6620603ca59d0e2daa1fc296a6fe59.svg";
export { ForwardRef as ReactComponent };